import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import { useNavigate } from 'react-router';
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Iconify from 'src/components/iconify';
//

// ----------------------------------------------------------------------

export default function UserTableRow({
  row,
  selected,
  onEditRow,
  onSelectRow,
  onDeleteRow,
  projectId,
}) {
  const { id, phoneNumber, company, role, date, platform, paymentMethod, status } = row;

  const confirm = useBoolean();
  const navigate = useNavigate();
  const popover = usePopover();

  return (
    <>
      <TableRow hover selected={ selected }>
        <TableCell padding="checkbox">
          <Checkbox checked={ selected } onClick={ onSelectRow } />
        </TableCell>
        <TableCell
          style={ { cursor: 'pointer', color: 'blue' } }
          onClick={ () => {
            const path = `/dashboard/technical-database/cost-codes/costCodes-show-page/${row.id}`;
            console.log('Navigating to:', path);
            navigate(path);
          } }
        >
          { id }
        </TableCell>
        <TableCell sx={ { whiteSpace: 'nowrap' } }>{ phoneNumber }</TableCell>
        <TableCell sx={ { whiteSpace: 'nowrap' } }>{ company }</TableCell>
        <TableCell sx={ { whiteSpace: 'nowrap' } }>{ role }</TableCell>
        <TableCell sx={ { whiteSpace: 'nowrap' } }>{ date }</TableCell>
        <TableCell sx={ { whiteSpace: 'nowrap' } }>{ platform }</TableCell>
        <TableCell sx={ { whiteSpace: 'nowrap' } }>{ paymentMethod }</TableCell>
        <TableCell sx={ { whiteSpace: 'nowrap' } }>{ status }</TableCell>

        <TableCell align="right" sx={ { px: 1, whiteSpace: 'nowrap' } }>
          <IconButton color={ popover.open ? 'inherit' : 'default' } onClick={ popover.onOpen }>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      {/* <UserQuickEditForm currentUser={ row } open={ quickEdit.value } onClose={ quickEdit.onFalse } /> */ }

      <CustomPopover
        open={ popover.open }
        onClose={ popover.onClose }
        arrow="right-top"
        sx={ { width: 140 } }
      >
        <MenuItem
          onClick={ () => {
            confirm.onTrue();
            popover.onClose();
          } }
          sx={ { color: 'error.main' } }
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem>

        <MenuItem
          onClick={ () => {
            onEditRow();
            popover.onClose();
          } }
        >
          <Iconify icon="solar:pen-bold" />
          Edit
        </MenuItem>
      </CustomPopover>

      <ConfirmDialog
        open={ confirm.value }
        onClose={ confirm.onFalse }
        title="Delete"
        content="Are you sure want to delete?"
        action={
          <Button variant="contained" onClick={ onDeleteRow }>
            Delete
          </Button>
        }
      />
    </>
  );
}

UserTableRow.propTypes = {
  onDeleteRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  row: PropTypes.object,
  selected: PropTypes.bool,
};
